import { createSelector } from 'reselect';
import { selectBonusOffersNotQualifiedAndActiveFormatted } from 'core/modules/BonusOffers/selectors';

export const selectBonusOffersFlexPage = state => state.bonusOffersFlexPage;

export const selectBonusOffersFlexPageConfig = createSelector(
  selectBonusOffersFlexPage,
  bonusOffersFlexPage => bonusOffersFlexPage.config,
);

// Return all offers without additional filtering
export const selectBonusOffers = selectBonusOffersNotQualifiedAndActiveFormatted;
